
import React from 'react';
import { usePresenceContext } from '@/contexts/PresenceContext';

interface UserStatusIndicatorProps {
  userId: string;
  showText?: boolean;
  className?: string;
}

export const UserStatusIndicator: React.FC<UserStatusIndicatorProps> = ({ 
  userId, 
  showText = true, 
  className = "" 
}) => {
  const { getUserStatus } = usePresenceContext();
  const status = getUserStatus(userId);

  console.log('UserStatusIndicator rendering for user:', userId, 'with global status:', status);

  const getStatusColor = (status: string) => {
    switch (status) {
      case 'online':
        return 'bg-green-500';
      case 'away':
        return 'bg-yellow-500';
      default:
        return 'bg-gray-400';
    }
  };

  const getStatusText = (status: string) => {
    switch (status) {
      case 'online':
        return 'Online';
      case 'away':
        return 'Away';
      default:
        return 'Offline';
    }
  };

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="relative">
        <div 
          className={`w-3 h-3 rounded-full ${getStatusColor(status)}`}
          title={getStatusText(status)}
        />
      </div>
      {showText && (
        <span className={`text-sm font-medium ${
          status === 'online' ? 'text-green-600' : 
          status === 'away' ? 'text-yellow-600' : 
          'text-gray-500'
        }`}>
          {getStatusText(status)}
        </span>
      )}
    </div>
  );
};
